import { Component } from "@angular/core";

@Component({
  selector: 'app-home',
  templateUrl: './initial.component.html',
  styleUrls: ['./initial.component.scss'],
})
export class InitialComponent {

}
